import { Navigate, useLocation } from "react-router-dom";

import { createRerouteRegex } from "App/routes/pageNames";
import { LegacyPagePaths } from "App/routes/paths";
import { useLiveOpsPathing } from "Pages/liveOps/useLiveOpsPathing";

export function AgentsRerouter(): JSX.Element {
    const location = useLocation();
    const { agentsBasePath } = useLiveOpsPathing();
    const pathAfterAgents = location.pathname.replace(createRerouteRegex(LegacyPagePaths.agents), "");
    const newPath = pathAfterAgents
        ? `${agentsBasePath}/${pathAfterAgents}${location.search}${location.hash}`
        : `${agentsBasePath}${location.search}${location.hash}`;
    return <Navigate to={newPath} replace />;
}
